import React from 'react';

export default (props) => {
    return <div className="pictureframe inset-text">{props.children}
        <div className="pictureframe-text">
            <span className="pictureframe-caption">{props.caption}</span>{props.credit&&props.caption?" ":""}<span className="pictureframe-credit">{props.credit}</span>
        </div> 
    </div>;
}


// WEBPACK FOOTER //
// ./src/js/components/PictureFrame/PictureFrame.jsx